/**
 * 初始化
 */
 import {ActionStack} from './actionStack'
 import {Zoom} from './zoom'
 import {Drag} from './drag'
 import {Pen} from './pen.js'
 import {Crop} from './crop.js'
 import {Model} from './model'
 
 import exportImg from './exportImg.js';
 import utils from './utils.js';
 import app from './app.js';
 
 export default {
     initApp: function(canvas, img, mask) {
         let _this = this
         if (!app.model) {
             let model = new Model(app.board.canvas)
             app.model = model
         }
 
         if (!app.pen) {
             this.initPen()
         }
         
         let zoom = new Zoom(canvas)
         app.zoom = zoom
 
         let drag = new Drag()
         app.drag = drag
 
         app.exportImg = exportImg
 
         this.initImage(canvas, img, mask)
         switch(app.lastModel) {
             case 1: 
                if($(window).width()>980){
                    $('.hb').click();
                }else{
                    $('.hb_mobile').click();
                }
                break;
             case 2: 
                $('.free_lasso').click();
                break;
             case 3: 
                $('.line_lasso').click();
                break;
             case 4: 
                $('.eraser').click();$('.eraser').click();
                break;
             case 5: 
                app.model.changeMode(app.beforeCropModel);
                break;
             default: 
                if($(window).width()>980){
                    $('.hb').click();
                }else{
                    $('.hb_mobile').click();
                }
                break;
         }
 
       
         // 放大缩小
         app.zoom.bindZoom(document.querySelector('.edit_box'), 
             app.board.canvas, 
             [app.board.canvas, app.board.cover], 
             function(w, h, l, t){
                 _this.setCropSize(w, h, l, t)
             }
         )
         app.zoom.bindClickZoomIn($('.enlarge'), 
             app.board.canvas, 
             [app.board.canvas, app.board.cover],
             function(w, h, l, t) {
                 _this.setCropSize(w, h, l, t)
             }
         )
         app.zoom.bindClickZoomOut($('.narrow'),
             app.board.canvas,
             [app.board.canvas, app.board.cover],
             function(w, h, l, t) {
                 _this.setCropSize(w, h, l, t)
             }
         )
     },
     initImage: function (canvas, img) {
 
         let actions = new ActionStack(canvas, mask, 'paint')
         app.actions = actions
 
         // 撤销恢复
         app.actions.bindBtn($('.undo'), $('.redo'))
         app.actions.checkBtn()
         $('.header .left i').show()
         $('.header .left label').show();
         $('.header .mobile_box>label').css({'visibility':'initial'});
         $('.header .mobile_box .crop_tab').addClass('show');
         $('.header .mobile_box .down').addClass('show');
         $('.function_desk_mobile').addClass('active');
         $('.edit_box>.uploadBox').hide();
         
         canvas.width = mask.width = img.width
         canvas.height = mask.height = img.height
 
         if (!app.crop) {
             app.uploadFile.imageShowSizeRatio(img)
 
             canvas.style.width = (img.width * app.uploadFile.ratio) + 'px'
             canvas.style.height = (img.height * app.uploadFile.ratio) + 'px'
             canvas.style.top = '50%'
             canvas.style.left = '50%'
         }
         
         //canvas.style.backgroundImage = 'url('+img.src+')'
         canvas.style.backgroundImage = 'url('+utils.getBase64Image(img)+')'
 
         let ctxMask = mask.getContext('2d')
         ctxMask.save()
         ctxMask.fillStyle = '#000'
         ctxMask.fillRect(0, 0, mask.width, mask.height)
         ctxMask.restore()
     },
     setCropSize: function (w, h, l, t) {
         if (app.crop) {
             let container = app.crop.container,
                 box = app.crop.cropBox;
             container.style.width = w +'px';
             container.style.height = h +'px';
             container.style.left = l +'px';
             container.style.top = t +'px';
             box.style.width = w * app.crop.cropBoxXScale + 'px'
             box.style.height = h * app.crop.cropBoxYScale + 'px'
             box.style.top = h * app.crop.cropBoxTopscale + 'px'
             box.style.left = w * app.crop.cropBoxLeftScale + 'px'
         }
     },
     setCropBoxSize: function () {
         if (app.crop) {
             let container = app.crop.container,
                 box = app.crop.cropBox;
 
             box.style.width = container.offsetWidth * app.crop.cropBoxXScale + 'px'
             box.style.height = container.offsetHeight * app.crop.cropBoxYScale + 'px'
             box.style.top = container.offsetHeight * app.crop.cropBoxTopscale + 'px'
             box.style.left = container.offsetWidth * app.crop.cropBoxLeftScale + 'px'
             app.model.updateCropCover()
         }
     },
     initPen: function() {
         let pen = new Pen();
         app.pen = pen
         //初始化画笔对象
         app.pen.init('.pensize-box', '.pensize-dot', '.pen-value')
         //实时监听画笔尺寸值改变
         app.pen.bindPenSizeChangeRealTime()
         //监听画笔尺寸值改变
         app.pen.bindPenSizeChange()
         //拖拽圆点改变画笔大小
         app.pen.bindMoveEvent()
         // 点击拖动条事件
         app.pen.bindClickEvent()
         $('.pen-value').on('mousewheel', function(e) {
             if (e.deltaY == 1 && app.pen.penSize < 120) {
                 app.pen.penSizeChange(app.pen.penSize+1)
                 app.model.changeLineWidth(app.pen.penSize);
             }
             if (e.deltaY == -1 && app.pen.penSize > 1) {
                 app.pen.penSizeChange(app.pen.penSize-2)
                 app.model.changeLineWidth(app.pen.penSize);
             }
         })
     }
 }